import { render, staticRenderFns } from "./form.vue?vue&type=template&id=1f1e47cf&scoped=true"
import script from "./form.js?vue&type=script&lang=js&external"
export * from "./form.js?vue&type=script&lang=js&external"
import style0 from "./form.scss?vue&type=style&index=0&id=1f1e47cf&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e47cf",
  null
  
)

export default component.exports